<script setup lang="ts">
import AppTable from "@/components/app-table.vue";
import { TableColumn } from "@/models/table-column";
import { RouteName } from "@/router";
import { notificationsService } from "@/services/notifications-service";
import { onBeforeMount, ref } from "vue";
import { useRouter } from "vue-router";
import { invitationService } from "@/services/invitation-service";
import type { InvitationDTO } from "@/models/dtos/invitation-dto";
import { mdiThumbUp } from "@mdi/js";

const router = useRouter();

const pageLoading = ref(false);
const invitationColumns = ref([
  TableColumn.for("customerNumber", "Kundnummer"),
  TableColumn.for("customerName", "Kundnamn"),
  TableColumn.for("createdBy", "Kundadmin"),
  TableColumn.for("invitedUser", "Användare"),
  TableColumn.for("approve", "Skicka inbjudan", { sort: false }),
]);
const invitations = ref<InvitationDTO[]>([]);

onBeforeMount(async () => {
  try {
    pageLoading.value = true;
    invitations.value = await invitationService.getPendingInvitations();
  } catch (error) {
    notificationsService.open({
      text: "Något gick fel vid hämtning av inbjudningarna.",
      type: "error",
      error,
    });
  } finally {
    pageLoading.value = false;
  }
});

function onClickRow(invitation: InvitationDTO) {
  router.push({
    name: RouteName.Customer,
    params: {
      customerNumber: invitation.customerNumber,
    },
  });
}
async function inviteUser(invitation: InvitationDTO) {
  try {
    await invitationService.inviteUser(invitation);
  } catch (error) {
    const t = error as { text: string };
    notificationsService.open({
      text: t.text, // 'Något gick fel vid inbjudning av användaren.',
      type: "error",
      error,
    });
  } finally {
    invitations.value = invitations.value.filter((i) => i.id !== invitation.id);
  }
}
</script>

<template>
  <section class="section px-0">
    <div class="columns is-justify-content-space-between">
      <div class="column">
        <p class="title is-4">Användare som väntar på inbjudan</p>
      </div>
    </div>

    <app-loader v-if="pageLoading"></app-loader>
  </section>

  <section
    v-if="!pageLoading"
    class="section notification has-background-savoy-blue-light"
  >
    <app-table
      :columns="invitationColumns"
      :items="invitations"
      :loading="pageLoading"
      @click:row="onClickRow"
    >
      <template #column:approve="{ item }">
        <button
          class="button is-success is-light"
          :class="{ 'is-loading': pageLoading }"
          @click="inviteUser(item)"
        >
          <span class="icon">
            <app-icon :icon="mdiThumbUp" size="16" />
          </span>
          <span>Godkänn</span>
        </button>
      </template>
    </app-table>
  </section>
</template>
